export type AppEnvironment = "development" | "staging" | "production";

export interface ClientEnvironment {
  appEnvironment: AppEnvironment;
  supabaseUrl?: string;
  supabasePublishableKey?: string;
  aiUiEnabled: boolean;
  authRedirectUrl: string;
}

function parseEnvironment(value: string | undefined): AppEnvironment {
  if (value === "staging" || value === "production") {
    return value;
  }

  return "development";
}

export const clientEnvironment: ClientEnvironment = {
  appEnvironment: parseEnvironment(import.meta.env.VITE_APP_ENV),
  ...(import.meta.env.VITE_SUPABASE_URL ? { supabaseUrl: import.meta.env.VITE_SUPABASE_URL } : {}),
  ...(import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY
    ? {
        supabasePublishableKey:
          import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? import.meta.env.VITE_SUPABASE_ANON_KEY,
      }
    : {}),
  aiUiEnabled: import.meta.env.VITE_AI_UI_ENABLED === "true",
  authRedirectUrl: import.meta.env.VITE_AUTH_REDIRECT_URL?.trim() || "https://v2.shirazdiscus.ir",
};
